import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Subject, BehaviorSubject, throwError } from 'rxjs';

import { APIOperationResult } from '../_models/apioperation-result';
import { DeleteDateRangeModel } from '../_models/delete-date-range-model';
import { UserSubmittableDataBatch } from '../_models/user-submittable-data-batch';
import { UserSubmittableDataRecord } from '../_models/user-submittable-data-record';

export class UserSubmittableService {

  public submitBatchWorking: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public submitBatchResult: EventEmitter<APIOperationResult> = new EventEmitter<APIOperationResult>();

  public presubmitValidationWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public presubmitValidationResult: BehaviorSubject<APIOperationResult> = new BehaviorSubject<APIOperationResult>(null);

   public currentBatch: BehaviorSubject<UserSubmittableDataBatch> = new BehaviorSubject<UserSubmittableDataBatch>(null);

   public currentDetailsRecord: BehaviorSubject<UserSubmittableDataRecord> = new BehaviorSubject<UserSubmittableDataRecord>(null);
   public currentDetailsRecordWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

   protected _controllerName = "submittable";

   constructor(
    public httpClient: HttpClient
   ) {
     
   }

   error(error: HttpErrorResponse) {

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    console.log(error.message);

    return throwError(errorMessage);
  }

  public handleSubmitBatchError(errorResponse: HttpErrorResponse) {
    var ret: string = "horse";
     
    return throwError(ret);
  }

  public handleDeleteError(errorResponse: HttpErrorResponse) {
    var ret: string = "Error while deleting.";

    return throwError(ret);
  }

  protected convertToActuallyUTC(date: Date, h: number, mm: number, s: number) {
    let y = date.getFullYear();
    let m = date.getMonth();
    let d = date.getDate();

    let utcDate = new Date(y,m,d, h, mm, s);

    return utcDate;
  }

  public GetEmptyDailySubmittableBatch(wellId: number, beginDate: Date, endDate: Date, useLastSubmission: boolean) {

    let lBeginDate = beginDate.getTime() / 1000;
    let lEndDate = endDate.getTime() / 1000;

    let tzo = beginDate.getTimezoneOffset();

    let tzoms = tzo * 60.0;

    let lBeginDateActuallyUtc = this.convertToActuallyUTC(beginDate, 12, 0, 0).getTime() / 1000;
    let lEndDateActuallyUtc = this.convertToActuallyUTC(endDate, 12,0,0).getTime() / 1000;

    let suls = "false";

    if(useLastSubmission == true) {
      suls = "true";
    }

    let url = "api/" + this._controllerName + "/Empty?wellId=" + wellId + "&begin=" + lBeginDateActuallyUtc + "&end=" + lEndDateActuallyUtc + "&useLastSubmission=" + suls ;

    this.httpClient.get(url).pipe(catchError(this.handleSubmitBatchError)).subscribe((result: UserSubmittableDataBatch) => {

      let injBatch = <UserSubmittableDataBatch> result;

      this.currentBatch.next(injBatch);
    },
    (result) => {

    });
  }

  public SubmitBatch(dataBatch: UserSubmittableDataBatch): void {

    dataBatch.submitMode = "u";

    if (!this.submitBatchWorking.value) {
      this.submitBatchWorking.next(true);

      this.httpClient.post("api/" + this._controllerName + "/Submit", dataBatch).pipe(catchError(this.handleSubmitBatchError)).subscribe((result: any) => {

        var opResult = <APIOperationResult>result;

        this.submitBatchWorking.next(false);
        this.submitBatchResult.emit(opResult);
      }, (result) => {
          var opResult = <APIOperationResult>result;

          this.submitBatchWorking.next(false);
          this.submitBatchResult.emit(opResult);
      });
    }
  }

  public SubmitMultiWellBatch(dataBatch: UserSubmittableDataBatch, injectionType: string): void {

    dataBatch.submitMode = "u";

    if (!this.submitBatchWorking.value) {
      this.submitBatchWorking.next(true);

      this.httpClient.post("api/" + injectionType + "/SubmitMulti", dataBatch).pipe(catchError(this.handleSubmitBatchError)).subscribe((result: any) => {

        var opResult = <APIOperationResult>result;

        this.submitBatchWorking.next(false);
        this.submitBatchResult.emit(opResult);
      }, (result) => {
        var opResult = <APIOperationResult>result;

        this.submitBatchWorking.next(false);
        this.submitBatchResult.emit(opResult);
      });
    }
  }

  public doPresubmitValidation(dataBatch: UserSubmittableDataBatch) : void {

    dataBatch.submitMode = "u";

    if(!this.presubmitValidationWorking.value) {
      this.presubmitValidationWorking.next(true);

      this.httpClient.post("api/" + this._controllerName + "/PresubmitValidation", dataBatch).pipe(catchError(this.handleSubmitBatchError)).subscribe((result: any) => {
        var opResult = <APIOperationResult>result;

        this.presubmitValidationWorking.next(false);
        this.presubmitValidationResult.next(opResult);
      }, (result) => {
          var opResult = <APIOperationResult>result;

          this.presubmitValidationWorking.next(false);
          this.presubmitValidationResult.next(opResult);
      });
    }
  }

  public clearPresubmitValidation() {
    this.presubmitValidationWorking.next(true);
    this.presubmitValidationResult.next(null);
  }

  public deleteRecord(record: UserSubmittableDataRecord) {
    var ret;

    ret = <Promise<APIOperationResult>>this.httpClient.delete("api/" + this._controllerName + "/" + record.Id).pipe(catchError(this.handleDeleteError)).toPromise();

    return ret;
  }
  public DeleteInjectionDateRange(dateRangeArgs: DeleteDateRangeModel): Promise<APIOperationResult> {
    var ret;

    ret = <Promise<APIOperationResult>>this.httpClient.post("api/injection/deleterange", dateRangeArgs).pipe(catchError(this.handleDeleteError)).toPromise();

    return ret;
  }

  
  public GetRecord(id: number): Promise<UserSubmittableDataRecord> {
    var ret;

    if (id == null) {
      ret = new Promise<UserSubmittableDataRecord>((resolve, reject) => {
        resolve(null);
      });
    }
    else {
      ret = <Promise<UserSubmittableDataRecord>>this.httpClient.get("api/" + this._controllerName + "/" + id).toPromise();
    }

    return ret;
  }

  public UpdateRecord(inj: UserSubmittableDataRecord): Promise<APIOperationResult> {
    var ret;

    ret = <Promise<APIOperationResult>> this.httpClient.post("api/" + this._controllerName + "/update", inj).pipe(catchError(this.handleSubmitBatchError)).toPromise();

    return ret;
  }

  public DeleteRecord(inj: UserSubmittableDataRecord): Promise<APIOperationResult> {
    var ret;

    ret = <Promise<APIOperationResult>>this.httpClient.delete("api/" + this._controllerName + "/" + inj.Id).pipe(catchError(this.handleDeleteError)).toPromise();

    return ret;
  }

  public DeleteDateRange(dateRangeArgs: DeleteDateRangeModel): Promise<APIOperationResult> {
    var ret;

    ret = <Promise<APIOperationResult>>this.httpClient.post("api/" + this._controllerName + "/deleterange", dateRangeArgs).pipe(catchError(this.handleDeleteError)).toPromise();

    return ret;
  }
}
